import { useForm } from "react-hook-form";
import PermissionForm from "./PermissionForm";

const ModalAddPermission = (props) => {
  const { isOpen, onOk, onCancel } = props;
  const hookForm = useForm({
    defaultValues: {},
  });
  return (
    <PermissionForm
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      hookForm={hookForm}
    />
  );
};
export default ModalAddPermission;
